import { render, staticRenderFns } from "./RestaurantItem.vue?vue&type=template&id=2735e8f8&scoped=true&"
import script from "./RestaurantItem.vue?vue&type=script&lang=js&"
export * from "./RestaurantItem.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantItem.vue?vue&type=style&index=0&id=2735e8f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2735e8f8",
  null
  
)

export default component.exports